import { TaskState } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';

// contains logic for managing outbound call tasks

export function setOutboundCallToOffered(
  context: InboxContext,
  sessionId: string,
  outgoingNumber: string,
) {
  context.logger.info('outbound call Offered', sessionId);

  let task = TasksModule.findOutboundCallTask(outgoingNumber);

  // we should have a task for this outbound call task already by `TaskModule.createOutboundCallTask`
  if (!task) {
    // create a task if for some reason it doesn't exist
    task = TasksModule.createTask({
      id: sessionId,
      from: outgoingNumber,
      displayName: outgoingNumber,
      direction: 'outbound',
      type: 'voice',
      state: TaskState.Pending,
    });
  } else {
    // since the pending task was created with a temporary session id (`tmp-outbound`), update the sessionId for the task
    TasksModule.updateTaskId(task, sessionId);
  }
  TasksModule.setTaskState(sessionId, TaskState.Offered);
  task.startedAt = new Date();
}

export function setOutboundCallToAccepted(
  context: InboxContext,
  sessionId: string,
) {
  context.logger.info('outbound call Accepted', sessionId);
  const task = TasksModule.getTask(sessionId);
  if (task) {
    TasksModule.setTaskState(sessionId, TaskState.Accepted);
  }
}

export function setOutboundCallToRejected(
  context: InboxContext,
  sessionId: string,
) {
  context.logger.info('outbound call Rejected', sessionId);
  const task = TasksModule.getTask(sessionId);
  if (task) {
    TasksModule.setTaskState(sessionId, TaskState.Rejected);
    TasksModule.deleteTask(sessionId);
  }
}

export function setOutboundCallToCompleted(
  context: InboxContext,
  sessionId: string,
) {
  context.logger.info('outbound call Completed', sessionId);

  TasksModule.setTaskState(sessionId, TaskState.Completed);
  TasksModule.deleteTask(sessionId);
}
